import { render, staticRenderFns } from "./v-custom-glued-fields.vue?vue&type=template&id=4dc9548e&"
import script from "./v-custom-glued-fields.vue?vue&type=script&lang=js&"
export * from "./v-custom-glued-fields.vue?vue&type=script&lang=js&"
import style0 from "./v-custom-glued-fields.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports